export const NEQRAW_AVATAR_IDS = ["boy-01", "boy-02", "girl-hijab", "girl-02"] as const;

export type NeqrawDefaultAvatarId = (typeof NEQRAW_AVATAR_IDS)[number];

export const NEQRAW_AVATAR_URI_PREFIX = "neqraw-avatar://";

export function avatarPhotoURL(id: NeqrawDefaultAvatarId) {
  return `${NEQRAW_AVATAR_URI_PREFIX}${id}`;
}

export function avatarIdFromPhotoURL(value: unknown): NeqrawDefaultAvatarId | null {
  if (typeof value !== "string" || !value.startsWith(NEQRAW_AVATAR_URI_PREFIX)) return null;
  const id = value.slice(NEQRAW_AVATAR_URI_PREFIX.length);
  return NEQRAW_AVATAR_IDS.includes(id as NeqrawDefaultAvatarId)
    ? (id as NeqrawDefaultAvatarId)
    : null;
}

export function isPresetAvatarPhotoURL(value: unknown): value is string {
  return avatarIdFromPhotoURL(value) !== null;
}

export function isRemoteAvatarPhotoURL(value: unknown): value is string {
  return typeof value === "string" && /^https:\/\/[^\s]+$/i.test(value.trim());
}

export function isSupportedAvatarPhotoURL(value: unknown): value is string {
  return isPresetAvatarPhotoURL(value) || isRemoteAvatarPhotoURL(value);
}
